




import { Component, mixins } from '@niknevis/vue-modules'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTd from '@/modules/common/tes-table/components/shared/TesTd.vue'
import { InjectReactive } from 'vue-property-decorator'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import ShebaView from '@/modules/shared/components/shared/ShebaView.vue'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import { PredefinedAnswerType } from '@/modules/predefined-answer/models/predefined-answer-collection.model'
import AdminPredefinedAnswerActions
  from '@/modules/predefined-answer/components/admin/table/AdminPredefinedAnswerActions.vue'

@Component({
  components: {
    ShebaView,
    CopyableText,
    TextEllipsis,
    TesTr,
    TesTd,
    DateTooltipped
  }
})
export default class AdminPredefinedAnswerTableRow extends mixins<TesTableRow>(TesTableRow) {

  @InjectReactive()
  predefinedAnswers!: PredefinedAnswerType

  columnComponents = {
    text: {
      component: TextEllipsis,
      handler: (value) => ({ text: value })
    },
    actions: {
      component: AdminPredefinedAnswerActions,
      handler: (value, row, withData) => ({ predefinedAnswer: row, withData: withData })
    }
  }

}
